<script setup lang="ts">
const route = useRoute()
const { MENUS, findActiveNav } = useNavigation()

const filteredMenus = MENUS.filter((menu) => !menu.footer_only)

const navbar = useTemplateRef('navbar')
const navbarMenuMobileRef = useTemplateRef('navbarMenuMobileRef')

const showMobileMenu = ref(false)
const isBelowNavbar = ref(false)
const navbarHeight = ref(0)

watch(
  () => route.path,
  () => {
    showMobileMenu.value = false
  },
  { immediate: true }
)

const handleScroll = () => {
  isBelowNavbar.value = window.scrollY > navbarHeight.value
}

const updateNavbarHeight = () => {
  if (navbar.value) {
    navbarHeight.value = navbar.value.offsetHeight
  }
}

onMounted(() => {
  updateNavbarHeight()
  handleScroll()
  window.addEventListener('scroll', handleScroll)
  window.addEventListener('resize', updateNavbarHeight)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
  window.removeEventListener('resize', updateNavbarHeight)
})

const isBlogPage = computed(() => route.path.startsWith('/blog'))
</script>
<template>
  <nav
    ref="navbar"
    :class="
      cn(
        'sticky top-0 bg-background h-navbar-m lg:h-navbar z-100 translate-y-0 transition-all',
        {
          'border-b border-outline-variant': isBlogPage,
          'lg:bg-transparent lg:pt-2': isBelowNavbar && !isBlogPage
        }
      )
    "
  >
    <UiContainer
      :class="
        cn('transition-all border-transparent', {
          'lg:bg-background lg:pl-5 lg:pr-3 lg:relative lg:border lg:border-outline-variant/30 lg:rounded-full lg:shadow-lg':
            isBelowNavbar && !isBlogPage
        })
      "
    >
      <UiLoadingIndicator class="bottom-0" />
      <div class="flex lg:grid lg:grid-cols-7 items-center py-2">
        <div v-if="!!navbarMenuMobileRef?.selectedChildNav" class="lg:hidden">
          <UiButton
            icon="material-symbols:arrow-back"
            icon-size="xl"
            size="lg"
            class="p-2 ring-0 hover:bg-surface-container-high"
            variant="outline"
            @click="navbarMenuMobileRef?.resetSelectedChild()"
          />
        </div>
        <NuxtLink
          to="/"
          aria-label="Home"
          :class="
            cn(
              'flex flex-1 lg:flex-none transition-all lg:col-span-2 lg:justify-start py-1.5 lg:order-0',
              {
                'justify-center': !!navbarMenuMobileRef?.selectedChildNav
              }
            )
          "
        >
          <UiLogoDefault />
        </NuxtLink>
        <template v-if="!route.path.startsWith('/promotion')">
          <NavbarMenu
            class="flex-1 transition-all lg:col-span-3 relative top-0 overflow-visible h-auto w-auto left-0 justify-center hidden lg:flex shadow-none bg-transparent"
            :menus="filteredMenus"
            :active-nav="findActiveNav"
          />
          <NavbarMenuMobile
            ref="navbarMenuMobileRef"
            v-model="showMobileMenu"
            class="lg:hidden"
            :menus="filteredMenus"
            :active-nav="findActiveNav"
          />
        </template>
        <NavbarCta :promo="route.path.startsWith('/promotion')" />
        <div class="lg:hidden">
          <UiButton
            :icon="
              showMobileMenu
                ? 'material-symbols:close'
                : 'material-symbols:menu'
            "
            icon-size="xl"
            size="lg"
            class="p-2 ring-0 hover:bg-surface-container-high flex cursor-pointer transition-all"
            :class="{
              'rotate-90': showMobileMenu
            }"
            variant="outline"
            @click="showMobileMenu = !showMobileMenu"
          />
        </div>
      </div>
    </UiContainer>
  </nav>
</template>
